import { useQuery } from '@tanstack/react-query';

import { type InParkingCardDetail } from 'src/features/cards/types/card';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';

import type { ListDTO } from 'src/types';

interface Query extends ListDTO {
    parkingId: string;
}

interface ParkingCardsQuery extends Query {
    id: string;
}

export const getParkingCards = ({ parkingId, id }: ParkingCardsQuery): Promise<InParkingCardDetail | null> => {
    return axios.get(`/parkings/${parkingId}/cards/${id}/`);
};

type ParkingCardsQueryFnType = typeof getParkingCards;
type UseParkingCardsOptions = {
    parkingId: string;
    id: string;
    config?: QueryConfig<ParkingCardsQueryFnType>;
};

export const useGetParkingCards = ({ parkingId, id, config }: UseParkingCardsOptions) =>
    useQuery({
        queryKey: ['parkingCardsRetrieve', parkingId, id],
        queryFn: async () => {
            if (!id) return null;
            return await getParkingCards({ parkingId, id });
        },
        ...config,
    });
